import React, { Component } from 'react';
import { Col, Container, Row } from 'reactstrap';
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TasksBoard from '../../components/DashboardElements/TasksBoard';
import DashboardStats from '../../components/DashboardElements/DashboardStats';

class TasksDashboard extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Dashboard" breadcrumbItem="Dashboard" />
            {/* Render Breadcrumbs */}
            <DashboardStats></DashboardStats>
            <Row>
              <Col lg={8}>
                <TasksBoard></TasksBoard>
              </Col>
              <Col lg={4}></Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default TasksDashboard;
